"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  LiveActivities: () => LiveActivities,
  WidgetUI: () => import_view2.WidgetUI,
  Widgets: () => Widgets
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native = require("react-native");
var import_view = require("./view");
var import_unavailable = require("./unavailable");
var import_view2 = require("./view");
function bridge() {
  var native = import_react_native.NativeModules.OneWidgetsBridge;
  if (!native) throw new Error("iOS widgets require native.app.ios.widgets and a new iOS build");
  return native;
}
var nativeWidgets = Object.freeze({
  write(data) {
    return bridge().writeWidget(data.title, data.value, data.subtitle);
  },
  writeView(view) {
    return bridge().writeView((0, import_view.encodeWidgetView)(view));
  }
});
var nativeLiveActivities = Object.freeze({
  start(title, state) {
    var push = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return bridge().start(title, state.status, state.value, push);
  },
  startView(title, view) {
    var push = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return bridge().startView(title, (0, import_view.encodeActivityView)(view), push);
  },
  update(id, state) {
    return bridge().update(id, state.status, state.value);
  },
  updateView(id, view) {
    return bridge().updateView(id, (0, import_view.encodeActivityView)(view));
  },
  end(id) {
    return bridge().end(id);
  },
  pushToken(id) {
    return bridge().pushToken(id);
  },
  onPushToken(listener) {
    var subscription = new import_react_native.NativeEventEmitter(bridge()).addListener("oneLiveActivityPushToken", listener);
    return function() {
      return subscription.remove();
    };
  }
});
function androidLimit(operation) {
  return new Error(`${operation} requires an iOS native build`);
}
var androidWidgets = Object.freeze({
  write(_data) {
    return Promise.reject(androidLimit("Widgets.write"));
  },
  writeView(_view) {
    return Promise.reject(androidLimit("Widgets.writeView"));
  }
});
var androidLiveActivities = Object.freeze({
  ...import_unavailable.LiveActivities,
  start(_title, _state) {
    var _push = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return Promise.reject(androidLimit("LiveActivities.start"));
  },
  startView(_title, _view) {
    var _push = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return Promise.reject(androidLimit("LiveActivities.startView"));
  },
  update(_id, _state) {
    return Promise.reject(androidLimit("LiveActivities.update"));
  },
  updateView(_id, _view) {
    return Promise.reject(androidLimit("LiveActivities.updateView"));
  },
  end(_id) {
    return Promise.reject(androidLimit("LiveActivities.end"));
  },
  onPushToken(_listener) {
    throw androidLimit("LiveActivities.onPushToken");
  }
});
var Widgets = import_react_native.Platform.OS === "android" ? androidWidgets : nativeWidgets;
var LiveActivities = import_react_native.Platform.OS === "android" ? androidLiveActivities : nativeLiveActivities;
//# sourceMappingURL=index.native.js.map
